import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminUserGroupIDOCToArray} from "../../../../util/Payload";

class AdminUserGroupEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.AdminUserGroup-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.AdminUserGroup-001";

        let foreignKeyName = "";

        let fk = {};
        fk[foreignKeyName] = foreignKey;

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_user_groups",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminUserGroupIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminUserGroup = {};

        adminUserGroup["USID"] = this.getAttributeValue("USID");
        adminUserGroup["Name"] = this.getAttributeValue("Name");
        adminUserGroup["PrimaryEmployeeUSID"] = this.getAttributeValue("PrimaryEmployeeUSID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminUserGroup-001";
        payload.ShifamedMessage.AdminUserGroup = adminUserGroup;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/admin_user_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminUserGroup-001",
                "idoc-response": "v1.AdminUserGroup-001"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminUserGroupIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminUserGroup-001";
        payload.ShifamedMessage.AdminUserGroup = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_user_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminUserGroup-001",
                "idoc-response": "v1.AdminUserGroup-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminUserGroupIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

}

export default AdminUserGroupEnterpriseComponent;